import './KidsVidsDivider.css';

interface KidsVidsDividerProps {
  variant?: 'default' | 'bottom';
}

export default function KidsVidsDivider({ variant = 'default' }: KidsVidsDividerProps) {
  return (
    <div className={`kidsvids-divider ${variant}`}>
      {/* This creates the "glow" or shadow coming from the section above */}
      <div className="depth-shadow"></div>
      
      {/* The stacked bars - we use the brand's earthy palette */}
      <div className="bar bar-top"></div>
      <div className="bar bar-mid">
        <div className="subtle-texture"></div>
      </div>
      <div className="bar bar-accent"></div>
      
      {/* Optional: A small "notch" or "tab" to center the eye */}
      <div className="divider-tab">
        <span className="heart-icon">❤</span>
      </div>
    </div>
  );
}
